import script from "./TaskEventInline.vue?vue&type=script&setup=true&lang=ts"
export * from "./TaskEventInline.vue?vue&type=script&setup=true&lang=ts"

import "./TaskEventInline.vue?vue&type=style&index=0&id=45d6ffee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45d6ffee"]])

export default __exports__